import { AxiosInstance, AxiosPromise } from 'axios'
import { ArticleTemplate } from '/@src/models/content'
import { SearchRequestParam } from '/@src/models/api'
import {
  ItemsResponse,
  KVResult,
  PushResult,
  tasksResponse,
} from '/@src/models/api'

export function fetchArticleTemplate(
  api: AxiosInstance
): Promise<Array<ArticleTemplate>> {
  return api.get('/v1/kvconfig/editor-article-template')
}

export function postArticleTemplate(
  api: AxiosInstance,
  value: Array<ArticleTemplate>
): Promise<Array<ArticleTemplate>> {
  return api.post('/v1/admin/kv/editor-article-template', {
    key: 'editor-article-template',
    value: value,
    name: '编辑器模板',
  })
}

export function fetchKV<T>(
  api: AxiosInstance,
  key: string
): Promise<KVResult<T>> {
  return api.get(`/v1/admin/kv/${key}`)
}

export function postKV<T>(
  api: AxiosInstance,
  key: string,
  name: string,
  value: T
): Promise<KVResult<T>> {
  return api.post(`/v1/admin/kv/${key}`, {
    key: key,
    value: value,
    name: name,
  })
}

export function fetchKVList(
  api: AxiosInstance,
  limit: number,
  anchor: number
): Promise<ItemsResponse<KVResult<string>>> {
  return api.get(`/v1/admin/kv/list?orderby=updated_at desc`, {
    params: {
      limit: limit,
      anchor: anchor,
    },
  })
}

export function fetchPushList(
  api: AxiosInstance,
  page: number,
  size: number,
  platform: string,
  keyword: string,
  status: number | string
): Promise<tasksResponse<PushResult<string>>> {
  return api.get(`/v1/admin/push/umeng/list`, {
    params: {
      platform,
      keyword,
      status,
      page,
      size,
    },
  })
}

interface Task {
  err_code?:string
  err_msg?:string
}

// 撤回
export function cancelUmengTask(
  api: AxiosInstance,
  taskId: string
): Promise<Task> {
  return api.post(`/v1/admin/push/umeng/${taskId}/cancel`)
}

// 同步状态
export function refreshUmengTaskStatus(
  api: AxiosInstance,
  taskId: string
): AxiosPromise {
  return api.get(`/v1/admin/push/umeng/${taskId}/status`)
}

//搜索
export function getUmengTaskList(
  api: AxiosInstance,
  params: SearchRequestParam
): Promise<tasksResponse<PushResult<string>>>  {
  return api.get(`/v1/admin/push/umeng/list?`, {
    params: params,
  })
}

// 详情
export function getUmengTaskDetail(
  api: AxiosInstance,
  taskId: string
): Promise<PushResult<string>> {
  return api.get(`/v1/admin/push/umeng/${taskId}/detail`)
}
